import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getUserId } from '../../../../../helpers/cookies';
import Modal from 'components/GeneralComponents/Modal';
import EditGroupComponent from './EditGroupComponent';
import GenericConfirmActionModal from 'pages/CommunityMergeFeed/CreateFeed/GenericConfirmActionModal';
import AddRemoveMembersModal from 'pages/CommunityMergeFeed/CreateFeed/AddRemoveMembersModal';
import elements from '../../elements';
import styled from './styled';
import './GroupComponent.scss';

class GroupComponent extends React.Component {
  state = {
    channelMembers: [],
    location: null,
    openEdit: false,
    showLeaveModal: false,
    showDeleteGroupModal: false,
    leftChannel: null,
    showAddRemoveMembersModal: false,
  };

  componentDidMount() {
    this.setInitialData();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.activeChannel !== this.props.activeChannel ||
      prevProps.allUsers !== this.props.allUsers ||
      prevProps.managers !== this.props.managers ||
      prevProps.associates !== this.props.associates ||
      prevProps.activeChannelRefreshToken !== this.props.activeChannelRefreshToken
    ) {
      this.setChannelMembers();
    }
  }

  setInitialData = () => {
    const { locations, locationId } = this.props;
    this.setChannelMembers();

    const currentLocation = locations?.find(
      (location) => location.id === parseInt(locationId)
    );
    if (currentLocation) {
      this.setState({ location: currentLocation });
    }
  };

  setChannelMembers = () => {
    const { activeChannel, allUsers, managers, associates } = this.props;
    if (!activeChannel || !Array.isArray(allUsers) || !Array.isArray(managers) || !Array.isArray(associates)) return;
    const activeUsersList = managers.concat(associates);
    const members = activeUsersList.filter(
      (user) =>
        user.user &&
        user.status === 'active' &&
        user.user.channel_ids.includes(activeChannel.id)
    );
    this.setState({ channelMembers: members });
  };

  toggleModal = (key, value) => {
    this.setState({ [key]: value });
  };

  handleClose = (e) => {
    e.preventDefault();
    this.props.resetActiveSidePane();
  };

  handleLeaveChannel = () => {
    const { handleRemoveUserFromGroup, activeChannel, allUsers } = this.props;
    const currentUserId = parseInt(getUserId());
    const currentUser = allUsers.find((user) => user.owner_id === currentUserId);

    if (currentUser) {
      handleRemoveUserFromGroup(activeChannel.id, [currentUser]);
    }
    this.toggleModal('showLeaveModal', false);
    this.toggleModal('showDeleteGroupModal', false);
    this.setState({ leftChannel: activeChannel });
  };

  handleDeleteChannel = () => {
    const { handleDeleteGroup, activeChannel, allUsers } = this.props;
    handleDeleteGroup(activeChannel.id, allUsers);
    this.toggleModal('showDeleteGroupModal', false);
    this.setState({ leftChannel: activeChannel });
  };

  notifyCancel = () => this.toggleModal('openEdit', false);

  notifySaveChanges = (channelId, name, description) => {
    this.toggleModal('openEdit', false);
    this.props.updateChannelInfo(channelId, name, description);
  };

  handleToggleMute = () => {
    const { activeChannel, updateChannelMuteStatus, active } = this.props;
    const sub = active?.subscriptions;
    if (!sub || !activeChannel?.id) return;

    const newMuteValue = !sub.subscription_mute_notifications;
    updateChannelMuteStatus(activeChannel.id, sub.id, newMuteValue);
  };

  render() {
    const {
      activeChannel, active, setActiveSidePane,
      allUsers, addRemoveChannelUsers
    } = this.props;
    const {
      channelMembers, location, openEdit, showLeaveModal,
      showDeleteGroupModal, showAddRemoveMembersModal
    } = this.state;

    const channelId = activeChannel?.id;
    const subId = active?.subscriptions?.id;
    const channelName = activeChannel?.channel_name || '';
    const description = active?.subscriptions?.channel?.description || '';
    const channelType = activeChannel?.channel_type;
    const isLocationFeed = channelType === 'location_feed';
    const isCustomShyft = activeChannel?.shyft_channel;

    const numUsers = channelMembers.length || activeChannel?.member_count || 0;
    const isEditable = active?.userIsAdmin && active?.subscriptions && !['location_feed', 'region_feed'].includes(channelType) && !active.subscriptions.channel.shyft_channel;
    const shouldAllowMute = active?.subscriptions?.final_allow_mute;
    const shouldMuteSubscription = active?.subscriptions?.subscription_mute_notifications;
    const shouldAllowDeleteGroup = !isLocationFeed && !isCustomShyft && active?.subscriptions?.channel?.is_admin && active?.subscriptions?.channel?.final_allow_delete;
    const canAddRemoveMembersToGroup = !isLocationFeed && !isCustomShyft && active?.subscriptions?.channel?.is_admin;

    const avatarUrl =
      (channelType === 'location_feed' && location?.avatar_blob?.blob_url) ||
      (channelType === 'custom_feed' && activeChannel?.shyft_channel && '/icons/favicon.ico') ||
      '/icons/channel avatar.svg';

    return (
      <elements.ColumnWrap>
        <div className="group__wraps">
          <img src="/icons/week-picker-left.svg" onClick={this.handleClose} />
          <label className="group__titles">
            <FormattedMessage id="GroupComponent.headerLabel" defaultMessage="Group Settings" />
          </label>
          {isEditable && (
            <button
              className="group__button-more"
              onClick={() => this.toggleModal('openEdit', true)}
            />
          )}
        </div>

        <elements.ScrollWrap>
          <div className="group__inner-wraps">
            <styled.ChannelAvatar src={avatarUrl} />
            <label className="group__inner-titles">{channelName}</label>
            <label className="group__texts">
              <FormattedMessage id="GroupComponent.members" defaultMessage="+{value} members" values={{ value: numUsers }} />
            </label>
            <label className="group__descriptions">{description}</label>
            <label className="group__addresss">{location?.formatted_address || ''}</label>
          </div>

          <div className="group-settings">
            <div className="group-settings__item" onClick={() => setActiveSidePane('group-members')}>
              <img src="/icons/view-group-members.svg" alt="Members" className="icon" />
              <span>View Group Members</span>
              <img src="/icons/week-picker-right.svg" alt="Arrow" className="arrow" />
            </div>

            {canAddRemoveMembersToGroup && (
              <div className="group-settings__item" onClick={() => this.toggleModal('showAddRemoveMembersModal', true)}>
                <img src="/icons/add-group-members.svg" alt="Add Members" className="icon" />
                <span>Add Members</span>
                <img src="/icons/week-picker-right.svg" alt="Arrow" className="arrow" />
              </div>
            )}

            <div className="group-settings__item" onClick={() => setActiveSidePane('announcements')}>
              <img src="/icons/view-group-announcements.svg" alt="Announcements" className="icon" />
              <span>View Announcements</span>
              <img src="/icons/week-picker-right.svg" alt="Arrow" className="arrow" />
            </div>

            <div className="group-settings__item" onClick={() => setActiveSidePane('pins')}>
              <img src="/icons/view-group-pins.svg" alt="Pinned Posts" className="icon" />
              <span>View Pinned Posts</span>
              <img src="/icons/week-picker-right.svg" alt="Arrow" className="arrow" />
            </div>

            {shouldAllowMute && (
              <div className="group-settings__item custom-layout">
                <div className="text">
                  <img src="/icons/mute-channel.svg" alt="Mute" className="icon" />
                  <span>Mute Channel</span>
                </div>
                <div className="extra">
                  <label className="toggle-switch">
                    <input type="checkbox" checked={shouldMuteSubscription} onChange={this.handleToggleMute} />
                    <span className="slider" />
                  </label>
                </div>
              </div>
            )}

            {!isLocationFeed && !isCustomShyft && (
              <div className="group-settings__item custom-layout leave" onClick={() => this.toggleModal('showLeaveModal', true)}>
                <div className="text">
                  <img src="/icons/leave-channel.svg" alt="Leave" className="icon" />
                  <span>Leave Channel</span>
                </div>
              </div>
            )}

            {shouldAllowDeleteGroup && (
              <div className="group-settings__delete" onClick={() => this.toggleModal('showDeleteGroupModal', true)}>
                Delete Group
              </div>
            )}
          </div>

          {openEdit && (
            <Modal>
              <EditGroupComponent
                active={active}
                notifyCancel={this.notifyCancel}
                notifySaveChanges={this.notifySaveChanges}
              />
            </Modal>
          )}

          {showLeaveModal && (
            <GenericConfirmActionModal
              title={<FormattedMessage id="PostComponent.leaveGroup" defaultMessage="Leave Group?" />}
              message={
                <FormattedMessage
                  id="PostComponent.confirmLeaveContent"
                  defaultMessage="Are you sure you want to leave {group}"
                  values={{ group: channelName }}
                />
              }
              confirmLabel="Leave Group"
              actionType="leave"
              onCancel={() => this.toggleModal('showLeaveModal', false)}
              onConfirm={this.handleLeaveChannel}
            />
          )}

          {showDeleteGroupModal && (
            <GenericConfirmActionModal
              title="Delete Group"
              message="When you delete your group, all users will be removed from the group. The community group will be deleted, and you will no longer be able to post shifts to this group. This action cannot be undone."
              confirmLabel="Yes, Delete Group"
              actionType="delete-group"
              onCancel={() => this.toggleModal('showDeleteGroupModal', false)}
              onConfirm={this.handleDeleteChannel}
            />
          )}

          {showAddRemoveMembersModal && (
            <AddRemoveMembersModal
              channelId={activeChannel.id}
              mode="add"
              allUsers={allUsers}
              channelUsers={channelMembers}
              onClose={() => this.toggleModal('showAddRemoveMembersModal', false)}
              onConfirm={(selectedUserIds, channelId, mode) => {
                addRemoveChannelUsers(selectedUserIds, channelId, mode, subId);
                this.toggleModal('showAddRemoveMembersModal', false);
              }}
              title="Add Group Members"
              confirmLabel="Add"
            />
          )}

          <styled.Overlay display={openEdit ? 'block' : 'none'} />
        </elements.ScrollWrap>
      </elements.ColumnWrap>
    );
  }
}

GroupComponent.propTypes = {
  setActiveSidePane: PropTypes.func.isRequired,
  resetActiveSidePane: PropTypes.func.isRequired,
  updateChannelInfo: PropTypes.func.isRequired,
  handleRemoveUserFromGroup: PropTypes.func.isRequired,
  allUsers: PropTypes.array.isRequired,
  locations: PropTypes.array.isRequired,
  locationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  activeChannel: PropTypes.object,
  active: PropTypes.object,
};

GroupComponent.defaultProps = {
  activeChannel: null,
  active: null,
};

export default injectIntl(GroupComponent);
